import BillieEilish from "assets/images/about-us/artists/billie-eilish.png";
import Lizzo from "assets/images/about-us/artists/lizzo.png";
import KatyPerry from "assets/images/about-us/artists/katy-perry.png";
import SnoopDogg from "assets/images/about-us/artists/snoop-dogg.png";
import RickJames from "assets/images/about-us/artists/rick-james.png";
import Weezer from "assets/images/about-us/artists/weezer.png";
import Devo from "assets/images/about-us/artists/devo.png";
import RunDmc from "assets/images/about-us/artists/run-dmc.png";
import BillyRayCyrus from "assets/images/about-us/artists/billy-ray-cyrus.png";
import LazyLoad from "components/LazyLoad";

import { Root, Content, Paragraph, GridContainer, StyledGrid, Logo } from "./styles";

const BILLIE_EILISH = { logo: BillieEilish, alt: "Billie Eilish" };
const LIZZO = { logo: Lizzo, alt: "Lizzo" };
const KATY_PERRY = { logo: KatyPerry, alt: "Katy Perry" };
const SNOOP_DOGG = { logo: SnoopDogg, alt: "Snoop Dogg" };
const RICK_JAMES = { logo: RickJames, alt: "Rick James" };
const WEEZER = { logo: Weezer, alt: "Weezer" };
const DEVO = { logo: Devo, alt: "Devo" };
const RUN_DMC = { logo: RunDmc, alt: "Run DMC" };
const BILLY_RAY_CYRUS = { logo: BillyRayCyrus, alt: "Billy Ray Cyrus" };

const LOGOS = [BILLIE_EILISH, LIZZO, KATY_PERRY, SNOOP_DOGG, RICK_JAMES, WEEZER, DEVO, RUN_DMC, BILLY_RAY_CYRUS];

const Artists = () => {
  return (
    <Root>
      <Content align="center">
        <Paragraph variant="large" data-testid="about-us-artists-paragraph">
          We’re constantly updating our music library with pop stars, hip hop moguls, and rock legends. Here’s a few top
          names…
        </Paragraph>
        <GridContainer container justifyContent="center" textAlign="center">
          {LOGOS.map((item) => (
            <StyledGrid item xs={5} key={item.alt}>
              <LazyLoad lazy>
                <Logo src={item.logo} alt={item.alt} width={501} widthMobile={132} />
              </LazyLoad>
            </StyledGrid>
          ))}
        </GridContainer>
      </Content>
    </Root>
  );
};

export default Artists;
